import * as React from 'react'
import { styled } from 'mz-ui-kit'
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'mz-intl';
import messages from '../messages.intl';
import Button from 'mz-ui-kit/core/Button'
import Alert from 'mz-ui-kit/core/Alert'
import { Link } from 'react-router-dom';
import FormErrors from 'app/components/book-trip/FormErrors';
import PickupInstructions from 'app/components/book-trip/PickupInstructions';
import Lightbox from 'mz-ui-kit/core/Lightbox'
import { BOOK_TRIP_FORM } from 'app/constants'
import { hasSubmitSucceeded, hasSubmitFailed, isValid } from 'redux-form'


const Container = styled('div', {
  marginTop: '30px',
})
const LinkSentContainer = styled('div', {
  width: '400px',
  padding: '20px',
})
const LinkSentHeader = styled('h3', {})
const LinkSentBody = styled('p', {})
const ButtonWrapper = styled('div', {
  marginTop: '10px',
})
const AlertContainer = styled('div', {
  marginBottom: '10px',
  marginTop: '10px',
})

export default function SendBookingLink({ onClick, loading }) {
  const [submitted, setSubmitted] = React.useState(false)
  const submitFailed = useSelector(hasSubmitFailed(BOOK_TRIP_FORM))
  const submitSucceeded = useSelector(hasSubmitSucceeded(BOOK_TRIP_FORM))
  const formIsValid = useSelector(isValid(BOOK_TRIP_FORM))

  async function handleClick() {
    // PaidBooking send a function as a first argument to the onClick handler
    // which creates a payment data, but BookingLink do not have any payment
    // login so we just send "null" instead of that function, and let the later
    // stages of the booking flow to figure out what to do with it
    await onClick(null)
    if (formIsValid) {
      setSubmitted(true)
    }
  }

  return (
    <Container>
      <PickupInstructions />
      <FormErrors />
      {submitFailed && formIsValid && submitted && (
        <AlertContainer>
          <Alert color="red">
            <FormattedMessage message={messages.SUBMIT_FAILED} />
          </Alert>
        </AlertContainer>
      )}
      <ButtonWrapper>
        <Button size="medium" color="GREEN" onClick={handleClick} loading={loading}>
          <FormattedMessage message={messages.SEND_BOOKING_LINK} />
        </Button>
      </ButtonWrapper>
      <Lightbox
        showed={submitSucceeded}
        closable={false}
        render={() => (
          <LinkSentContainer>
            <FormattedMessage tagName={LinkSentHeader} message={messages.BOOKING_LINK_SENT_HEADER} />
            <FormattedMessage tagName={LinkSentBody} message={messages.BOOKING_LINK_SENT_BODY} />

            <Button $as={Link} to="/">
              <FormattedMessage message={messages.BOOKING_LINK_BACK} />
            </Button>
          </LinkSentContainer>
        )}
      />
    </Container>
  )
}
